import React, { useEffect, useState } from 'react';
import { MDBContainer, MDBRow, MDBCol } from 'mdbreact';
import { useHistory } from 'react-router';
import { Button, Card, Input, StrongPasswordInput } from 'react-rainbow-components';
import logo from '../../images/logos/logo.webp'

const Password: React.FC = () => {

    const [username, setusername] = useState<string>('')
    const [password, setPassword] = useState<string>('')
    const [confirmPassword, setConfirmPassword] = useState<string>('')
    const [passwordError, setpasswordError] = useState<string>()
    const [error, setError] = useState<String>('');
    const [loading, setLoading] = useState<boolean>(false);
    const [passwordStrength, setpasswordStrength] = useState<"strong" | "weak" | "average" | undefined>(undefined)

    const history = useHistory();

    useEffect(() => {
        if (password.length === 0) {
            setpasswordStrength(undefined);
        }else
        if (password.length <= 3) {
            setpasswordStrength('weak');
        }else
        if (password.length > 3 && password.length < 10) {
            setpasswordStrength('average');
        }else{
            setpasswordStrength('strong');
        }
        if (password !== confirmPassword ) {
            setpasswordError("Les mot de passe ne sont pas les memes")
        } else {
            setError("")
            setpasswordError("");
        }
       
    }, [password, confirmPassword])

    const changePassword = async () => {
        if (password === confirmPassword && password !== '' && confirmPassword !== '' && username !== '') {
            setLoading(true)
            setError("");
            setpasswordError("");
            const RequestInit = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ username: username, password: password })
            };
            await fetch('https://admin.radioemotion.be/api/resetPassword', RequestInit)
                .then(response => response.json())
                .then(response => {
                    setLoading(false)
                    if (response.response) {
                        history.push('/login')
                    } else {
                        setError(response.err)
                    }
                })
                .catch(err => {
                    setLoading(false)
                    setError("un problème est survenu lors de l'envoie");
                })
        }else{
            setpasswordError('Veuillez remplir correctement tous les champs')
        }
    }

    return (
        <>
            <MDBContainer className="h-100vh">
                <MDBRow className="justify-content-center align-content-center align-middle h-100">
                    <MDBCol md="4" sm="8">
                        <Card>
                            <MDBCol size={"8"} className="offset-2">
                                <img
                                    src={logo}
                                    alt="logo of radio emotion"
                                    className="mt-4 mb-4"
                                />
                            </MDBCol>
                            <MDBCol size={"10"} className="offset-1 mb-2 mt-2">
                                <Input
                                    label="Nom d'utilisateur"
                                    placeholder="Entrez votre nom d'utilisateur"
                                    type="text"
                                    isCentered={true}
                                    className="mb-4"
                                    onChange={(event) => setusername(event?.currentTarget?.value)}
                                    value={username}
                                />
                            </MDBCol>
                            <MDBCol size={"10"} className="offset-1 mb-2 mt-2">
                                <StrongPasswordInput
                                    label="Nouveau mot de passe"
                                    placeholder="*******"
                                    className="mb-4"
                                    bottomHelpText="Le mot de passe doit contenir au moins 10 caractères"
                                    passwordState={passwordStrength}
                                    error={passwordError}
                                    onChange={(event) => setPassword(event?.currentTarget?.value)}
                                    value={password}
                                />
                            </MDBCol>
                            <MDBCol size={"10"} className="offset-1 mb-2 mt-2">
                                <Input
                                    label="Confirmer votre mot de passe"
                                    placeholder="Confirmer votre mot de passe"
                                    type="password"
                                    error={passwordError}
                                    className="mb-4"
                                    onChange={(event) => setConfirmPassword(event?.currentTarget?.value)}
                                    value={confirmPassword}
                                />
                            </MDBCol>
                            {error !== '' ? <MDBCol> <p className="red-text text-center font-weight-bold">{error}</p></MDBCol> : <MDBCol></MDBCol>}
                            <MDBCol size={"10"} className="offset-1 mb-4">
                                <Button
                                    isLoading={loading}
                                    label="Modifier le mot de passe"
                                    onClick={() => changePassword()}
                                    variant="brand"
                                    className='w-100 mt-2'
                                />
                            </MDBCol>
                        </Card>
                    </MDBCol>
                </MDBRow>
            </MDBContainer>
        </>
    );
}

export default Password;
